import React from "react";
import { PaymentDetailsStyled } from "./style";
import { formatNumber, formatDate } from "../../utils/helpers";
export var PaymentDetails = function (_a) {
    var data = _a.data;
    return (React.createElement(PaymentDetailsStyled, null,
        React.createElement("tbody", { className: "tbodyDetail" },
            React.createElement("tr", null,
                React.createElement("td", { className: "typeInvoice" }, data.typeInvoice),
                React.createElement("td", null)),
            React.createElement("tr", null,
                React.createElement("td", null, "Franquicia:"),
                React.createElement("td", { className: "totalDetailValue" }, data.franchise)),
            React.createElement("tr", null,
                React.createElement("td", null, "Fecha de pago:"),
                React.createElement("td", { className: "totalDetailValue" }, data.date && formatDate(data.date))),
            React.createElement("tr", null,
                React.createElement("td", null, "C\u00F3digo de autorizaci\u00F3n:"),
                React.createElement("td", { className: "totalDetailValue" }, data.authorizationCode != ""
                    ? data.authorizationCode
                    : "No aplica")),
            data.balance && data.balance <= 0 ? (React.createElement("tr", null,
                React.createElement("td", null, "Valor Total:"),
                React.createElement("td", { className: "totalDetailValue" },
                    "$ ",
                    data.payment && formatNumber(data.payment),
                    " COP"))) : (React.createElement(React.Fragment, null, data.typeInvoice != 'Factura de venta' ?
                React.createElement(React.Fragment, null,
                    React.createElement("tr", null,
                        React.createElement("td", null, "Abono:"),
                        React.createElement("td", { className: "totalDetailValue parcialPayment" },
                            "$ ",
                            data.payment && formatNumber(data.payment),
                            " COP")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Saldo restante:"),
                        React.createElement("td", { className: "totalDetailValue" },
                            "$ ",
                            data.balance && formatNumber(data.balance),
                            " COP"))) :
                React.createElement(React.Fragment, null,
                    React.createElement("tr", null,
                        React.createElement("td", null, "Total pagado:"),
                        React.createElement("td", { className: "totalDetailValue parcialPayment" },
                            "$ ",
                            data.total && formatNumber(data.total),
                            " COP"))))),
            React.createElement("tr", null,
                React.createElement("div", { className: "totalDivider" }),
                React.createElement("td", null)),
            React.createElement("tr", null,
                React.createElement("td", { className: "totalBorder" }),
                React.createElement("td", { className: "totalBorder" })),
            React.createElement("tr", null,
                React.createElement("td", { className: "totalPay" }, "Total:"),
                React.createElement("td", { className: "totalDetailValue totalStyle" },
                    "$ ",
                    data.total && formatNumber(data.total))))));
};
export default React.memo(PaymentDetails);
